import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { LicenseCompartments, licenseStorageKey } from '..';

export class LicenseAgreementListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(licenseStorageKey)
    private readonly cache: DataCache<LicenseCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('licenseAgreement');
        } else {
          this.cache.reset('licenseAgreement');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
